import { useJustificativaCondicoesDialog } from "./use-justificativa-condicoes-dialog";
import { JustificativaCondicoesDialogView } from "./view-justificativa-condicoes-dialog";
import type { JustificativaCondicoesDialogProps } from "./types-justificativa-condicoes-dialog";

export function JustificativaCondicoesDialog(props: JustificativaCondicoesDialogProps) {
  const vm = useJustificativaCondicoesDialog(props);

  return <JustificativaCondicoesDialogView {...props} {...vm} />;
}

export type * from "./types-justificativa-condicoes-dialog";
